import React, { useEffect, useState } from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
// import { EditPage } from '../components/EditPage'
import * as convenioApi from '../api/convenios'
import { useSelector } from 'react-redux'

const EditConvenio = ({ edit }) => {
  const translations = useSelector(state => state.translations.translations)
  const conveniosTranslations = translations['system-convenios']


  const selectedData = [
    {
      name: '_id',
      type: 'hidden',
      title: 'Id'
    },
    {
      name: 'name',
      type: 'text',
      title: "Nome do convênio",
      validation: {
        required: true
      },
      options: {
        maxLength: '150'
      },
    },
    {
      name: 'description',
      type: 'tiny',
      title: "Pequena descrição do convenio",
    },
    
    {
      name: 'image',
      type: 'dragdrop',
      title: 'Imagem',
      options: {
        maxFiles: 1
      },
      validation: {
        required: true
      },
    },
  ]
  return (
    <EditPage
      title={edit ? "Editar convenio" : "Adicionar Serviço"}
      subtitle={edit ? "Alterando informações do convenio" : "Adicionando informações do convenio"}
      selectedData={selectedData} 
      addFunction={convenioApi.addItem}
      fetchFunction={convenioApi.fetchItem}
      editFunction={convenioApi.editItem}
      uploadFunction={convenioApi.uploadConvenios}
      edit={edit}
      url='convenios'
    />
  )
}

export default EditConvenio
